import { Service } from '@roc/feature-app-core';

const url = {
  GET_DRAWS_BY_LOAN: '/api/v1/draws/getDrawsByLoanId',
  GET_DRAW_BY_ID: '/api/v1/draws/getDrawById',
  GET_DRAW_DTO_BY_ID: '/api/v1/draws/getDrawDTO',
  GET_ALL_DRAWS: '/api/v1/draws/getAllDraws',
  GET_POINT_OF_CONTACT: '/api/v1/draws/getPointOfContactDetails',
  UPDATE_POINT_OF_CONTACT: '/api/v1/draws/updatePointOfContactDetails',
  UPDATE_POINT_OF_CONTACT_MOBILE_SNAP: '/api/v1/loan/mobile_v2/pointOfContact/assignTask',
  GET_SOW_DOCUMENTS: '/api/v1/draws/getSOWDocuments',
  CANCEL_REQUEST: '/api/v1/draws/cancelDrawRequest',
  GET_BASIC_FIELDS: '/api/v1/draws/getBasicFields',
  UPDATE_DRAW_INFORMATION: '/api/v1/draws/updateDrawInformation',
  GET_BANK_INFO: '/api/v1/draws/getBankInfo',
  APPROVE_BANK_INFO: '/api/v1/draws/approveBankInformation',
  REJECT_BANK_INFO: '/api/v1/draws/rejectBankInformation',
  UPDATE_INSPECTION_INVOICE: '/api/v1/draws/updateInspectionInvoice',
  GET_DOCUMENT_STATUS: '/api/v1/draws/getDocumentStatus',
  WIRE_AUTHORIZATION: '/nportal/rest/priv/wireAuthorization',
  GET_DRAWS_AND_REVISION_BY_LOAN: '/api/v1/draws/getDrawsAndRevisionsByLoanId',
  GET_POINT_OF_CONTACTS_LIST: '/api/v1/loan/pointOfContact/getPointOfContactsByLoanId',
};

export class DrawService extends Service {
  getDrawsByLoanId(loanId: string, fetchAllDraws = false) {
    return this.get(`${url.GET_DRAWS_BY_LOAN}?loanId=${loanId}`, { fetchAllDraws });
  }
  getDocumentStatus(loanId: string, fileName: string) {
    return this.get(`${url.GET_DOCUMENT_STATUS}?loanId=${loanId}&fileName=${fileName}`);
  }

  getDrawsAndRevisionsByLoanId(loanId: string) {
    return this.get(url.GET_DRAWS_AND_REVISION_BY_LOAN, { loanId });
  }

  getDrawById(drawId: number) {
    return this.get(`${url.GET_DRAW_BY_ID}?drawId=${drawId}`);
  }

  getDrawDTOById(drawId: string) {
    return this.get(`${url.GET_DRAW_DTO_BY_ID}?drawId=${drawId}`);
  }

  getAllDraws(
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object
  ) {
    return this.get(
      url.GET_ALL_DRAWS,
      {
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
      },
      {
        disableGlobalLoading: page > 1,
      }
    );
  }

  getPointOfContact(loanId: string) {
    return this.get(`${url.GET_POINT_OF_CONTACT}?loanId=${loanId}`);
  }
  getPointOfContactsList(loanId: string, type, propertyId, drawId, taskId) {
    return this.get(`${url.GET_POINT_OF_CONTACTS_LIST}`,{ loanId, type, propertyId, drawId, taskId });
  }

  updatePointOfContact(drawId: number, pointOfContact) {
    return this.put(`${url.UPDATE_POINT_OF_CONTACT}?drawId=${drawId}`, pointOfContact);
  }
  createPointOfContactMobileSnap(loanId, pointOfContact) {
    return this.post(`${url.UPDATE_POINT_OF_CONTACT_MOBILE_SNAP}`, { ...pointOfContact, loanId, phone: pointOfContact?.phoneNumber });
  }

  getSOWDocuments(loanId: string) {
    return this.get(`${url.GET_SOW_DOCUMENTS}?loanId=${loanId}`);
  }

  cancelDrawRequest(drawId: number) {
    return this.post(`${url.CANCEL_REQUEST}?drawId=${drawId}`, {});
  }

  getBasicFields() {
    return this.get(url.GET_BASIC_FIELDS);
  }

  updateDrawInformation(drawInformation: any) {
    return this.put(`${url.UPDATE_DRAW_INFORMATION}`, drawInformation);
  }

  getBankInfo(entityId: number, entityType: string) {
    return this.get(url.GET_BANK_INFO, { entityId, entityType });
  }

  getWireAuthRequestId(loanId: number) {
    return this.get(`${url.WIRE_AUTHORIZATION}/getWireAuthLink?id=${loanId}`);
  }
  getWireAuth(loanId: number) {
    return this.get(`${url.WIRE_AUTHORIZATION}/getAllRequests`, {
      filters: {
        loanId: loanId.toString(),
      }
    });
  }

  rejectBankInfo(entityId: number, reason: string) {
    return this.put(url.REJECT_BANK_INFO, { entityId, reason });
  }

  approveBankInfo(entityId: number) {
    return this.put(url.APPROVE_BANK_INFO, { entityId });
  }

  updateInspectionInvoice(request: { drawId: number, invoiceNumber: string, invoiceDate: Date }) {
    return this.put(url.UPDATE_INSPECTION_INVOICE, request);
  }
}
